import React from "react";

const Stat_HOME = () => {
  return (
    <div>
      <h1>Stat HOME</h1>{" "}
    </div>
  );
};

export default Stat_HOME;
